import React from "react";
import { LayoutDashboard } from "lucide-react";
import { Link } from "react-router-dom";
import { SMARTBALLOT_FOX } from "../assets/smartBallotFox";

export default function Header({ active = "home" }) {
  return (
    <header
      data-testid="app-header"
      className="bg-gradient-brand-header sticky top-0 z-30 shadow-md"
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link" className="flex items-center gap-3">
          <img src={SMARTBALLOT_FOX} alt="SmartBallot fox" className="h-9 w-auto object-contain" />
          <div className="leading-tight">
            <p className="font-display font-700 text-lg text-white">SmartBallot</p>
            <p className="text-xs text-white/80 -mt-0.5">Proposal AI</p>
          </div>
        </Link>
        <nav className="flex items-center gap-2">
          <Link
            to="/?new=1"
            data-testid="nav-new-proposal-link"
            className={`text-sm font-medium px-3 py-1.5 rounded-full transition-colors ${
              active === "home" ? "bg-white/25 text-white" : "text-white/90 hover:text-white hover:bg-white/10"
            }`}
          >
            New Proposal
          </Link>
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className={`inline-flex items-center gap-1.5 text-sm font-medium px-3 py-1.5 rounded-full transition-colors ${
              active === "admin" ? "bg-white/25 text-white" : "text-white/90 hover:text-white hover:bg-white/10"
            }`}
          >
            <LayoutDashboard className="h-4 w-4" /> Admin
          </Link>
        </nav>
      </div>
    </header>
  );
}
